import { get } from 'lodash';
import { useActivityLogs } from '../../queries/activityLogQuery';
import { useGetInvoice } from '../../queries/invoiceQuery';
import { ActivityDrawer } from '../common/ActivityDrawer';

interface InvoiceActivityProps {
  isOpen: boolean;
  onClose: () => void;
  invoiceId: string;
  invoiceNumber: string;
}

export const InvoiceActivity = ({
  isOpen,
  onClose,
  invoiceId,
  invoiceNumber,
}: InvoiceActivityProps) => {
  const {
    data: activityData,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading: isActivityLoading,
  } = useActivityLogs(invoiceId, undefined, isOpen);

  // Fetch invoice to get commentHistory
  const { data: invoice } = useGetInvoice(invoiceId, {
    enabled: isOpen,
  });

  const activities = activityData?.pages.flatMap(page => page.data) || [];
  const commentHistory = get(invoice, 'commentHistory') as string | undefined;

  return (
    <ActivityDrawer
      isOpen={isOpen}
      onClose={onClose}
      invoiceNumber={invoiceNumber}
      activities={activities}
      isInitialLoading={isActivityLoading}
      isFetchingNextPage={isFetchingNextPage}
      hasNextPage={!!hasNextPage}
      fetchNextPage={fetchNextPage}
      commentHistory={commentHistory}
    />
  );
};
